import React from "react";
import { Document, Page, pdfjs } from 'react-pdf';
import PropTypes from "prop-types";
import { ClipLoader } from "react-spinners";
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
import { useTranslation } from "react-i18next";
function PdfThumbnail({ pdfUrl }) {
  const containerRef = React.useRef(null);
  const {t} = useTranslation();
  const [width, setWidth] = React.useState(null);
  const [error, setError] = React.useState(null);


  function onPageLoadSuccess() {
    if (containerRef.current) {
      setWidth(containerRef.current.offsetWidth);
    }
  }


  function onError(error) {
    setError(t("pdf_error"));
    console.error("Error loading PDF: ", error);
  }

  return (
    <div ref={containerRef}>
      {error && <div style={{ color: 'red' }}>{error}</div>}


      <Document
        file={pdfUrl}
        onLoadError={onError}
        loading={
          <div className="flex justify-center items-center h-[300px]">
            <ClipLoader color="#36D7B7" loading={true} size={50} />
          </div>
        }
      >

        <Page
          pageNumber={1}
          width={width || 300}
          renderMode="canvas"
          onLoadSuccess={onPageLoadSuccess}
        />
      </Document>
    </div>
  );
}

PdfThumbnail.propTypes = {
  pdfUrl: PropTypes.string.isRequired,
};

export default PdfThumbnail;
